import { useBlocksConfig } from "@pathwright/blocks-engine"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { BlockText } from "../../shared"
import { QuoteAttributionWrapper, StyledQuoteContainer } from "./ui"
import { isEmptyAttribution } from "./utils"

const Quote = (props) => {
  const { data, blockStyles } = props

  const { templateVariables } = useBlocksConfig()

  return (
    <StyledQuoteContainer blockStyles={blockStyles}>
      <BlockText
        html={data.quote}
        templateContext={templateVariables}
        style={{ margin: "10px 0" }}
      />
      {isEmptyAttribution(data.attribution) ? null : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <QuoteAttributionWrapper>
            <BlockText
              html={data.attribution}
              templateContext={templateVariables}
            />
          </QuoteAttributionWrapper>
        </div>
      )}
    </StyledQuoteContainer>
  )
}

export const QuoteContainer = (props) => {
  return (
    <Content.Container style={props.renderContainerStyles(props)}>
      {props.renderImage(props)}
      {props.renderQuote(props)}
    </Content.Container>
  )
}

const baseContainerStyles = {
  borderTop: "1px solid #ccc",
  borderBottom: "1px solid #ccc",
  padding: "20px 10px",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column"
}

QuoteContainer.defaultProps = {
  renderContainerStyles: (props) => baseContainerStyles,
  renderImage: (props) =>
    props.layout === "quoteImage" ? (
      <img
        src={props.data.image}
        alt={`Quote Author`}
        style={{ width: 80, height: 80, borderRadius: "100%" }}
      />
    ) : null,
  renderQuote: (props) => <Quote {...props} />
}

export default QuoteContainer
